module.exports = __webpack_public_path__ + "AbhiAstu-52c9e210.png";